import React, { useEffect, useState } from 'react';
import "./styles.css";
import {TextField, Button, IconButton, InputAdornment, CircularProgress} from '@material-ui/core/';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Grid from '@material-ui/core/Grid';
import Logo from '../../assets/imgs/prospect_brasil.png'
import LogoBora from '../../assets/imgs/bora.png'
import api from '../../services/api';
import { salvarAcesso, mensagemErro } from '../../services/acesso';
import { toast  } from 'react-toastify';

const Login = () => {
    const [email,setEmail] = useState("")
    const [password,setPassword] = useState("")
    const [redirect,setRedirect] = useState(false)
    const [loading, setLoading] = useState(false);
    const [emailAtivo, setEmailAtivo] = useState(false);
    const [mostrarEsqueci, setMostrarEsqueci] = useState(false);
    const [emailRecuperacao, setEmailRecuperacao] = useState("");
    const [enviandoLink, setEnviandoLink] = useState(false);
    const [mostrarSenha, setMostrarSenha] = useState(false);

    useEffect(() => {
        api.get("config-publica").then((result) => {
            setEmailAtivo(Boolean(result.data?.email_ativo));
        }).catch(() => {
            setEmailAtivo(false);
        });
    }, []);

    const handleLogin = async (event) => {
        if (event) event.preventDefault();

        if(!email) {
            toast.error("Informe seu e-mail");
            return
        }

        if(!password) {
            toast.error("Senha obrigatória");
            return
        }

        setLoading(true);

        await api.post("login", {
            email,
            password
        }).then(function(response){
            const login = response.data
            setLoading(false);
            localStorage.setItem("access_token", login.access_token);
            salvarAcesso(login.user);
            setRedirect(true)
            toast.success("Login realizado");
        })
        .catch(function (error) {
            localStorage.setItem("access_token","");
            setLoading(false);
            toast.error(mensagemErro(error, "Não autorizado"));
        })
    };

    const enviarLink = async () => {
        if (!emailRecuperacao) {
            toast.error("Informe o e-mail");
            return;
        }
        setEnviandoLink(true);
        try {
            const result = await api.post("esqueci-senha", { email: emailRecuperacao });
            toast.success(result.data?.message || "Se o e-mail estiver cadastrado, enviaremos um link para redefinir a senha.");
        } catch (error) {
            toast.error(mensagemErro(error, "Não foi possível enviar o link"));
        } finally {
            setEnviandoLink(false);
        }
    };

    if(redirect) {
        var host = window.location.protocol + "//" + window.location.host;
        window.location.href = `${host}/home`;
    }

    return (
    <div className="bodylogin">
        <form className="form_login" onSubmit={handleLogin}>
            <div className="logo-form-login" >
                <img src={Logo} width={200} alt="Prospect Brasil" />
            </div>

            <Grid item style={{paddingTop: "30px"}}>
                <TextField required id="login_email" type="email" autoComplete="username" autoFocus label="E-mail" onChange={(event) => setEmail(event.target.value)} value={email} fullWidth />
            </Grid>
            <Grid item style={{paddingTop: "30px"}}>
                <TextField
                    required
                    id="login_senha"
                    type={mostrarSenha ? "text" : "password"}
                    autoComplete="current-password"
                    label="Senha"
                    onChange={(event) => setPassword(event.target.value)}
                    value={password}
                    fullWidth
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label={mostrarSenha ? "Ocultar senha" : "Mostrar senha"}
                                    onClick={() => setMostrarSenha((v) => !v)}
                                    edge="end"
                                    size="small"
                                >
                                    {mostrarSenha ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>
            <Grid item style={{paddingTop: "30px",display:"flex",alignItems:"center",justifyContent:"center"}}>
                <Button variant="contained" color="primary" disabled={loading} type="submit" fullWidth size="large"
                    startIcon={loading ? <CircularProgress size={18} color="inherit" /> : null}>
                    {loading ? "Entrando..." : "Entrar"}
                </Button>
            </Grid>
            <Grid item style={{marginBottom:"10px",paddingTop: "20px",display:"flex",alignItems:"center",justifyContent:"center"}}>
                <Button type="button" onClick={() => {
                    setMostrarEsqueci((valor) => !valor);
                    if (!emailRecuperacao) setEmailRecuperacao(email);
                }}>
                    Esqueci a senha
                </Button>
            </Grid>
            {mostrarEsqueci && (
                emailAtivo ? (
                    <>
                        <Grid item>
                            <TextField label="E-mail para o link" type="email" autoComplete="email" value={emailRecuperacao} onChange={(event) => setEmailRecuperacao(event.target.value)} fullWidth />
                        </Grid>
                        <Grid item style={{paddingTop: "16px", display:"flex", justifyContent:"center"}}>
                            <Button variant="contained" color="primary" type="button" disabled={enviandoLink} onClick={enviarLink}>
                                Enviar link
                            </Button>
                        </Grid>
                    </>
                ) : (
                    <p style={{textAlign:"center"}}>Peça ao administrador do CRM um link de redefinição de senha</p>
                )
            )}
        </form>
        <div className="logo-bora" >
            <img src={LogoBora} width={200} alt="" />
        </div>
    </div>
  )
}

export default Login;
